import "./base.js";

window.AssessmentBuilder ??= {};
window.AssessmentBuilder.Models ??= {};

AssessmentBuilder.Models.SubmitterInfo = class SubmitterInfo extends AssessmentBuilder.Models.Base {
  defaults() {
    return {
      position: "after",
      instructions: "Tell us a little about yourself",
      showUsername: true,
      showEmail: true,
      showBirthday: false,
      showZipCode: false,
      showPhoneNumber: false,
      showComments: false,
      image: null, // ThumbnailEditor JSON that controls the image
    };
  }
};
